import "sanitize.css";
import "./src/styles.scss";
import RootProvider from "./src/contexts/root-provider";

export const wrapRootElement = RootProvider;
